<template>
    <el-main class="pageLayoutBody">
        <div class="pageSearch">
            <el-form ref="form" :model="form" class="pageFormLine" label-width="88px">
                
                <el-form-item label="操作人：" prop="bank">
                    <el-select v-model="form.id" placeholder="请选择操作人" size="small">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="(item, i) in user" :key="i" :label="item.username" :value="item.userId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间：" prop="date">
                    <el-date-picker size="small" v-model="form.date" type="daterange" placeholder="请选择时间" value-format="yyyy-MM-dd" :clearable="false" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="dateOptions" style="width: 100%"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" :loading="isSearchLoading" @click="searchList">查询</el-button>
                    <el-button type="default" size="small" @click="resetFields()">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="pageBody">
            <el-table :data="listData" style="width: 100%" v-loading="isRequestLoading" element-loading-text="加载中...">
                <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                <el-table-column prop="createAt" label="操作时间" min-width="150px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createName" label="操作人" min-width="120px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="accessColumn" label="操作栏目" min-width="120px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="accessModel" label="具体模块" min-width="150px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="accessDetail" label="日志" min-width="200px" show-overflow-tooltip align="center"></el-table-column>
               
            </el-table>

            <listPagination :pageNo="form.page" :listTotal="listTotal" @changeListPage="changeListPage" />
        </div>

   

    </el-main>


</template>

<script>
  import listPagination from '@/components/pagination/index'
  import {mapState} from "vuex";
  import {getLog} from "../../../../api/setting";
  import {getUserAll} from "../../../../api/user.js";
  export default {
    name: "settingOperate",
    data () {
      return {
        form: {
          id:'',
          date: [],
          page: 1,
          pageSize:10,
        },
        listTotal: 0,
        listData: [],
        isRequestLoading: false,
        isSearchLoading: false,
        formLabelWidth: '120px',
        user:[],
        businessBankList: [],
        dateOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          }
        },
      }
    },
    computed: {
      ...mapState({
        listKeepAlive: state => state.app.listKeepAlive,
      })
    },
    activated () {
      if (this.listKeepAlive.isInitPageNo) {
        this.form.page = 1
      }
      if (this.listKeepAlive.isReset) {
        this.$refs['form'].resetFields()
      }
      if (this.listKeepAlive.isQueryList) {
        this.getList()
      }
    },
    created(){
      this.getList()
      this.getUserAll()
    },
    methods: {
      resetFields(){
        this.form.date=[];
        this.form.id='';
      },
      getUserAll(){
        getUserAll().then(res => {
          console.log(res);
          this.user = res.data
        }).catch(() => {
         
        })
      },
      getList () {
        this.isRequestLoading = true  
        let formData = {
          id: '',
          beginDate:'',
          endDate:'',
          page: this.form.page,
          pageSize:10
        }
        console.log(formData)
        if (this.form.date.length > 0) {
          formData.beginDate = this.form.date[0]
          formData.endDate = this.form.date[1]
        }
        if(this.form.id!=''){
           formData.id= parseInt(this.form.id)
        }
        getLog(formData).then(res => {
          console.log(res);
          this.isRequestLoading = false
          this.isSearchLoading = false
          if (res.code == 0) {
            this.listData = res.data.records
            this.listTotal = res.data.total
          }
        }).catch(() => {
          this.isRequestLoading = false
          this.isSearchLoading = false
        })
      },
      changeListPage (val) {
        this.form.page = Number(val)
        this.getList()
      },
      searchList () {
        this.form.page = 1
        this.getList()
        this.isSearchLoading = true
      },
     
      
     
    
    },
    components: {
      listPagination
    }
  }
</script>
<style scoped>

</style>